module.exports = __webpack_public_path__ + "img/航协会员证书_01.1130cd4a.png";